/**
 * Composes multiple functions into a single function.
 *
 * @param {...Function} fns - The functions to compose.
 * @returns {Function} A new function that represents the composition of the input functions.
 *
 * @example Compose two functions
 * const add1 = x => x + 1;
 * const double = x => x * 2;
 * const composedFn = compose(double, add1);
 * console.log(composedFn(3)); // Output: 8 (double(add1(3)))
 */
export const compose =
  (...fns) =>
  (x) =>
    fns.reduceRight((y, f) => f(y), x);
